import React from 'react'
import styled, { createGlobalStyle } from 'styled-components'
import { Transition } from 'react-transition-group'
import { Theme } from '@pga/pga-component-library'

const GlobalStyle = createGlobalStyle`
  body {
    padding-right: ${props => props.isOpen ? '15px' : '0'};
    width: 100%;
  }
`

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(222, 226, 227, 0.9);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 1050;
  opacity: ${props => props.state === 'entered' ? 1 : 0};
  transition: opacity 150ms ease-in-out;
  overflow-y: scroll;
  padding: 1rem 0;
  min-height: 100%;
  height: auto;
`

const ModalContent = styled.div`
  background: white;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  max-width: 490px;
  width: 100%;
  position: relative;
  margin: 2rem auto;
  transform: ${props => props.state === 'entered' ? 'translateY(0)' : 'translateY(-25px)'};
  transition: transform 300ms ease-in-out;
  box-shadow: none;
  
  @media screen and (max-width: 576px) {
    min-width: 0px;
    width: 95%;
    margin: 1rem auto;
    max-height: none;
    overflow: visible;
  }
`

const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${props => props.hasCloseButton ? '16px 30px 0 30px' : '30px 30px 0 30px'};
  border-bottom: none;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
`

const CloseButtonBar = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: 10px;
`

const TitleBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
`

const Title = styled.h4`
  font-family: ${Theme.fonts.Montserrat};
  font-size: 20px;
  font-weight: bold;
  color: ${Theme.colors.primary};
  margin: 0;
`

const CloseButton = styled.button`
  padding: 0;
  margin: 0;
  background: none;
  border: 0;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.5;
  cursor: pointer;
  
  &:hover {
    opacity: 0.75;
  }
  
  &::before {
    content: "×";
  }
`

const ModalBody = styled.div`
  padding: 20px 30px 30px 30px;
  margin: 0;
`

export const StyledModal = ({ isOpen, onClose, children, title, closeButton = false }) => {
  if (!isOpen) return null

  return (
    <>
      <GlobalStyle isOpen={isOpen} />
      <Transition
        in={isOpen}
        timeout={300}
        appear
        unmountOnExit
      >
        {state => (
          <ModalOverlay onClick={onClose} state={state}>
            <ModalContent onClick={e => e.stopPropagation()} state={state}>
              <ModalHeader hasCloseButton={closeButton}>
                {closeButton && (
                  <CloseButtonBar>
                    <CloseButton onClick={onClose} aria-label='Close' />
                  </CloseButtonBar>
                )}
                <TitleBar>
                  {title && <Title>{title}</Title>}
                </TitleBar>
              </ModalHeader>
              <ModalBody>
                {children}
              </ModalBody>
            </ModalContent>
          </ModalOverlay>
        )}
      </Transition>
    </>
  )
}
